import { reactive } from 'vue'

export type HeaderOptions = {
  backgroundColor: 'bg-transparent' | 'bg-white'
  color: 'c-black' | 'c-white'
}

export const states = reactive({
  header: { backgroundColor: 'bg-transparent', color: 'c-black' } as HeaderOptions,
  map: { visible: false },
  menu: { visible: false },
  workingHours: { visible: false }
})

export const setHeaderStyle = (bgColor: HeaderOptions['backgroundColor'], color: HeaderOptions['color']) => {
  states.header.backgroundColor = bgColor
  states.header.color = color
}
